export default __webpack_public_path__ + "static/media/5-2.ef25696c.jpg";